import CoreConfigType from './coreConfigType';

export default {
  'auth-type': 'Mock',
  'auth-redirects-login': '',
  'auth-redirects-register': '',
  'auth-redirects-logout': '',
  'auth-redirects-user': '',
  'eventbus-write-to-console': false,
  'language-default': 'en',
  'networking-api-base-url': '',
  'networking-api-path': '',
  'networking-with-credentials': false,
  'networking-write-to-console': false,
} as CoreConfigType;
